<template>
    <div class="bg-white dark:bg-gray-800 overflow-hidden shadow rounded-lg">
        <div class="p-4">
            <div class="flex items-center">
                <div class="flex-shrink-0">
                    <div
                        :class="[
                            'w-8 h-8 rounded-md flex items-center justify-center',
                            bgColorClass,
                        ]"
                    >
                        <component
                            :is="icon"
                            :class="['w-5 h-5', iconColorClass]"
                            aria-hidden="true"
                        />
                    </div>
                </div>
                <div class="ml-4 w-0 flex-1">
                    <dl>
                        <dt
                            class="text-sm font-medium text-gray-500 dark:text-gray-400 truncate"
                        >
                            {{ title }}
                        </dt>
                        <dd
                            class="text-lg font-medium text-gray-900 dark:text-white"
                        >
                            {{ value }}
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
    title: string;
    value: string | number;
    icon: any;
    color?:
        | "blue"
        | "green"
        | "yellow"
        | "red"
        | "purple"
        | "indigo"
        | "pink"
        | "gray";
}

const props = withDefaults(defineProps<Props>(), {
    color: "blue",
});

const colorClasses = {
    blue: {
        bg: "bg-primary-500",
        icon: "text-white",
    },
    green: {
        bg: "bg-success-500",
        icon: "text-white",
    },
    yellow: {
        bg: "bg-warning-500",
        icon: "text-white",
    },
    red: {
        bg: "bg-danger-500",
        icon: "text-white",
    },
    purple: {
        bg: "bg-purple-500",
        icon: "text-white",
    },
    indigo: {
        bg: "bg-primary-500",
        icon: "text-white",
    },
    pink: {
        bg: "bg-pink-500",
        icon: "text-white",
    },
    gray: {
        bg: "bg-gray-500",
        icon: "text-white",
    },
};

const bgColorClass = computed(() => colorClasses[props.color].bg);
const iconColorClass = computed(() => colorClasses[props.color].icon);
</script>
